import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Route, RouteProps, RouteComponentProps, Redirect } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Footer from './Footer';
import { Store } from './types';
import Menu from './Menu';
import { fetchAll } from './actions/Actions';
import { getTokenFromCookies } from './helpers';
import LanguageMenu from './LanguagesMenu';

interface Props extends RouteProps {
    component: React.ComponentType<RouteComponentProps>;
}

const Body: React.FC<Props> = ({
    // eslint-disable-next-line destructuring/no-rename
    component: Component,
    ...rest
}) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const productCategories = useSelector(({ app }: Store) => app.productCategories);
    const products = useSelector(({ app }: Store) => app.products);
    const user = useSelector(({ app }: Store) => app.user);
    const users = useSelector(({ app }: Store) => app.users);
    const availableLanguages = useSelector(({ app }: Store) => app.availableLanguages);
    const categoryImages = useSelector(({ app }: Store) => app.categoryImages);
    const storeConfiguration = useSelector(({ app }: Store) => app.storeConfiguration);
    const tables = useSelector(({ app }: Store) => app.tables);
    const closures = useSelector(({ app }: Store) => app.closures);

    React.useEffect(() => {
        dispatch(fetchAll());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (
        !productCategories ||
        !products ||
        !user ||
        !users ||
        !categoryImages ||
        !availableLanguages ||
        !tables ||
        !storeConfiguration ||
        !closures
    ) {
        return null;
    }

    return (
        <Route
            {...rest}
            // eslint-disable-next-line react/jsx-no-bind
            render={props => (
                <div className='body'>
                    <div className='main'>
                        <div className='title'>
                            <LanguageMenu />
                            <div className='menu-title'>{t(props.match.url)}</div>
                        </div>
                        <div className='main-body'>
                            <Menu />
                            <Component {...props} />
                        </div>
                        <div className='footer'>
                            <Footer />
                        </div>
                    </div>
                </div>
            )}
        />
    );
};

const AuthorizedRoute: React.FC<Props> = ({
    // eslint-disable-next-line destructuring/no-rename
    component: Component,
    ...rest
}) => (
    <Route
        {...rest}
        // eslint-disable-next-line react/jsx-no-bind
        render={props =>
            getTokenFromCookies() ? (
                <Body {...props} component={Component} />
            ) : (
                <Redirect to='/error' />
            )
        }
    />
);

export default AuthorizedRoute;
